const carouselItems = [
  {
    id: 'car-1',
    title: '流浪地球3：人类终章',
    desc: '太阳急速老化，地球踏上2500年的流浪之旅。当人类面临终极抉择，是坚守还是放弃？郭帆导演携原班人马回归，国产科幻系列史诗终章。',
    tag: '科幻巨制',
    img: 'https://readdy.ai/api/search-image?query=Epic%20sci-fi%20movie%20visual%2C%20massive%20planet%20earth%20with%20glowing%20engines%20in%20deep%20space%2C%20orange%20and%20blue%20cosmic%20nebula%2C%20dramatic%20cinematic%20lighting%2C%20grand%20scale%2C%20film%20poster%20aesthetic&width=1000&height=500&seq=juzi-carousel-01&orientation=landscape',
  },
  {
    id: 'car-2',
    title: '繁花似锦：上海滩往事',
    desc: '九十年代的上海，机遇与挑战并存。阿宝从默默无闻到商界传奇，一段关于梦想、爱情与背叛的时代传奇。王家卫首部电视剧作品。',
    tag: '都市传奇',
    img: 'https://readdy.ai/api/search-image?query=Shanghai%20night%20cityscape%20in%201990s%20style%2C%20neon%20signs%20reflecting%20on%20wet%20street%2C%20elegant%20vintage%20cars%2C%20warm%20golden%20and%20red%20tones%2C%20romantic%20film%20noir%20atmosphere%2C%20cinematic%20wide%20shot&width=1000&height=500&seq=juzi-carousel-02&orientation=landscape',
  },
  {
    id: 'car-3',
    title: '长安十二时辰：烽火连城',
    desc: '上元节前夕，长安城暗流涌动。死囚张小敬临危受命，十二时辰内必须破解惊天阴谋。古装悬疑巅峰之作，每一帧都是电影级画面。',
    tag: '古装悬疑',
    img: 'https://readdy.ai/api/search-image?query=Ancient%20Chinese%20Tang%20dynasty%20city%20at%20night%2C%20red%20lanterns%20illuminating%20streets%2C%20palace%20architecture%2C%20dramatic%20lighting%2C%20mysterious%20atmosphere%2C%20epic%20historical%20cinematic%20aesthetic&width=1000&height=500&seq=juzi-carousel-03&orientation=landscape',
  },
  {
    id: 'car-4',
    title: '破晓行动：雷霆出击',
    desc: '国际贩毒集团渗透边境，特警突击队深入虎穴。真实案件改编，燃爆全场的国产军事动作片。林超贤执导，全程实景拍摄无替身。',
    tag: '动作犯罪',
    img: 'https://readdy.ai/api/search-image?query=Military%20action%20film%20visual%2C%20special%20forces%20team%20in%20tactical%20formation%2C%20urban%20warfare%20scene%2C%20explosive%20orange%20fire%20and%20smoke%2C%20intense%20dramatic%20lighting%2C%20war%20film%20cinematic%20aesthetic&width=1000&height=500&seq=juzi-carousel-04&orientation=landscape',
  },
  {
    id: 'car-5',
    title: '山海令：仙魔之争',
    desc: '上古神器重现人间，正邪两道群雄逐鹿。绝美仙侠世界与震撼视觉特效的完美融合，演绎一场跨越千年的爱恨纠葛。年度最受期待仙侠巨制。',
    tag: '仙侠传奇',
    img: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20landscape%20with%20floating%20mountains%2C%20ancient%20temples%20in%20clouds%2C%20golden%20sunlight%20breaking%20through%20mist%2C%20magical%20ethereal%20atmosphere%2C%20epic%20cinematic%20composition%2C%20traditional%20ink%20painting%20style&width=1000&height=500&seq=juzi-carousel-05&orientation=landscape',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="w-full py-16 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-black text-foreground-50">焦点推荐</h2>
          <p className="text-foreground-500 text-sm mt-2">编辑精选，不容错过的影视佳作</p>
        </div>

        <div className="flex flex-col gap-5">
          {carouselItems.map((item) => (
            <div
              key={item.id}
              className="group relative bg-background-100 rounded-2xl overflow-hidden border border-background-300/30 cursor-pointer hover:border-primary-500/30 transition-all duration-300"
            >
              <div className="flex flex-col md:flex-row">
                <div className="md:w-2/5 aspect-video md:aspect-auto overflow-hidden shrink-0">
                  <img
                    src={item.img}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                </div>
                <div className="flex-1 p-6 md:p-8 flex flex-col justify-center">
                  <div className="flex items-center gap-2 mb-3">
                    <span className="px-2.5 py-1 rounded-md bg-accent-500/15 text-accent-400 text-xs font-semibold whitespace-nowrap">
                      {item.tag}
                    </span>
                  </div>
                  <h3 className="text-foreground-50 font-black text-lg md:text-xl mb-3 group-hover:text-primary-400 transition-colors">
                    {item.title}
                  </h3>
                  <p className="text-foreground-500 text-sm leading-relaxed">{item.desc}</p>
                  <div className="mt-4">
                    <span className="inline-flex items-center gap-1.5 text-primary-400 text-sm font-medium cursor-pointer whitespace-nowrap">
                      立即观看 <i className="ri-arrow-right-line"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}